module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/toner@2x_10cad3.png";